import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'antd';
import * as settingActions from "~/containers/Settings/actions";
import SettingsVirtualTable from "../../components/SettingsVirtualTable";

var Origens = function(props) {
  var addTrigger = props.addTrigger || 0;
  var searchTerm = props.searchTerm || '';
  var settingsAcquisition = useSelector(function(state) { return state.settings["leads.acquisition"] || []; });
  var dispatch = useDispatch();

  var sorted = settingsAcquisition.slice().sort(function(a, b) {
    return (a.value || '').localeCompare(b.value || '');
  });

  var columns = [{ key: 'value', title: 'Nome', render: function(r) { return r.value; } }];

  var handleInlineEdit = function(record, newValue) {
    if (!newValue || !newValue.trim() || newValue.trim() === record.value) return;
    var existing = settingsAcquisition.find(function(i) { return i.value === newValue.trim() && i.id !== record.id; });
    if (existing) {
      Modal.confirm({
        title: "Já existe uma origem com este nome. Deseja mesclar?",
        content: "Esta ação não poderá ser revertida.",
        okText: "Sim", okType: "danger", cancelText: "Cancelar", zIndex: 1020,
        onOk: function() {
          dispatch(settingActions.mergeSetting({ data: { key: "leads.acquisition", value: newValue.trim() }, id: record.id }));
        },
      });
    } else {
      dispatch(settingActions.updateSetting({ data: { key: "leads.acquisition", value: newValue.trim() }, id: record.id }));
    }
  };

  var handleDelete = function(record) {
    dispatch(settingActions.deleteSetting({ id: record.id }));
  };

  var handleQuickAdd = function(value) {
    dispatch(settingActions.createSetting({ data: { key: "leads.acquisition", value: value } }));
  };

  return React.createElement(SettingsVirtualTable, {
    data: sorted, columns: columns, searchTerm: searchTerm,
    onInlineEdit: handleInlineEdit,
    onInlineDelete: handleDelete,
    onQuickAdd: handleQuickAdd,
    addTrigger: addTrigger,
    addLabel: 'Nova Origem',
  });
};

export default Origens;
